import React from 'react';
import ImageIcon from './image-icon';
import { Images } from '../../app-constants';

const PlayBlueIcon = () => <ImageIcon src={Images.BluePlay} alt="Play Blue" />;

export default PlayBlueIcon;
